module.exports = __webpack_public_path__ + "img/banner-wiki-text.e009cbcc.png";